import { render, staticRenderFns } from "./AbkQuickInfo.vue?vue&type=template&id=53b1a1b3&scoped=true&"
import script from "./AbkQuickInfo.vue?vue&type=script&lang=js&"
export * from "./AbkQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./AbkQuickInfo.vue?vue&type=style&index=0&id=53b1a1b3&scoped=true&lang=scss&"
import style1 from "./AbkQuickInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1a1b3",
  null
  
)

export default component.exports